import { render, staticRenderFns } from "./tuandco-result-price.vue?vue&type=template&id=dd5cc3de&"
import script from "./tuandco-result-price.vue?vue&type=script&lang=ts&"
export * from "./tuandco-result-price.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports